import { TowerPaymentsPairFormValues } from "./types";

export const defaultValues: TowerPaymentsPairFormValues = {
  paymentMethodId: "",
  pairCode: "",
};
